import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import SystemBanner from '../library/CMS/SystemBanner';
import { getCachedEnvConfig, loadEnvConfig, readSidebarBase } from '../../services/envConfig';
import { fetchSystemBannerRows, fetchSystemBannerRowsMultiScope, } from '../../services/systemBannerGrid';
/**
 * Renders every active (`SYSTEM_STATUS = 'A'`, plus `IS_SYSTEM = 'Y'` when unscoped) row matching
 * the given scope(s), stacked below the navbar — two independent, unrelated notices can both be
 * active for the same agency/permit at once, and both must show, not just the first one the API
 * happens to list, and a row matching more than one scope at once only shows once. Renders
 * nothing when no row matches. Safe to mount unconditionally, including many instances at once
 * (e.g. one per permit), each independently hiding/showing itself.
 */
const SystemBannerFromGrid = ({ enabled, flowId, pageSize = 1000, agencyName, permitTitle, scopes, sticky }) => {
    const [bannerPropsList, setBannerPropsList] = useState([]);
    const scopesKey = scopes ? JSON.stringify(scopes) : '';
    useEffect(() => {
        setBannerPropsList([]);
        if (enabled !== 'Y' || !flowId)
            return;
        let cancelled = false;
        (async () => {
            const env = getCachedEnvConfig() ?? (await loadEnvConfig());
            const sidebarBase = readSidebarBase(env);
            if (!sidebarBase)
                return;
            const rows = scopes
                ? await fetchSystemBannerRowsMultiScope(sidebarBase, flowId, pageSize, scopes)
                : await fetchSystemBannerRows(sidebarBase, flowId, pageSize, { agencyName, permitTitle });
            if (!cancelled)
                setBannerPropsList(rows);
        })();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, flowId, pageSize, agencyName, permitTitle, scopesKey]);
    if (enabled !== 'Y' || bannerPropsList.length === 0)
        return null;
    return (_jsx(_Fragment, { children: bannerPropsList.map((bannerProps, i) => (_jsx(SystemBanner, { ...bannerProps, sticky: sticky !== undefined ? sticky : bannerProps.sticky }, i))) }));
};
export default SystemBannerFromGrid;
